import colors from '@sportninja/common/constants/appColors'

export interface NodeTypePalette {
  /** Text / icon colour. */
  fg: string
  /** Background fill. */
  bg: string
}

/**
 * The colour a node type is drawn in: green season, red conference, blue
 * division, neutral team.
 *
 * Shared by the tree rail's letter badges and the detail panel's type pill so
 * the two cannot drift — the same node must not be red in one place and amber
 * in the other. Anything unrecognised falls back to the division treatment,
 * matching how `toNodeType` treats unknown API types.
 */
export const nodeTypePalette = (type: string): NodeTypePalette => {
  switch (type) {
    case 'season':
      return { fg: colors.SUCCESS_200, bg: `${colors.SUCCESS_200}29` }
    case 'conference':
      return { fg: colors.ERROR_200, bg: `${colors.ERROR_200}29` }
    case 'team':
      return { fg: colors.NEUTRAL_50, bg: colors.SECONDARY_200 }
    case 'division':
    default:
      return { fg: colors.INFO_300, bg: `${colors.INFO_300}29` }
  }
}
